'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiresExplicitConsentToProcess = undefined;

var _reselect = require('reselect');

var _gdprConsentToProcessEnabled = require('conversations-schema/operators/widget-data/gdprConsentToProcessEnabled');

var _gdprExplicitConsentRequired = require('conversations-schema/operators/widget-data/gdprExplicitConsentRequired');

var _getHasGivenConsentToProcess = require('./getHasGivenConsentToProcess');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var requiresExplicitConsentToProcess = exports.requiresExplicitConsentToProcess = (0, _reselect.createSelector)([_getWidgetData.getWidgetData, _getHasGivenConsentToProcess.getHasGivenConsentToProcess], function (widgetData, hasGivenConsentToProcess) {
  return Boolean((0, _gdprConsentToProcessEnabled.gdprConsentToProcessEnabled)(widgetData) && (0, _gdprExplicitConsentRequired.gdprExplicitConsentRequired)(widgetData) && !hasGivenConsentToProcess);
});


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/selectors/requiresExplicitConsentToProcess.js
// module id = 634
// module chunks = 2 3